import { WorkerRequirementStatus } from "@clipboard-health/contract-worker-app-bff";
import { useRef } from "react";
import { generatePath, useHistory } from "react-router-dom";

import { PageWrapper } from "../../../../components/PageWrapper";
import { StickyScrollPageHeader } from "../../../../components/StickyScrollPageHeader";
import { DOCUMENT_STRIPE_VERIFICATION_SELECT_SUBTYPE_FULL_PATH } from "../../../paths";
import { DocumentUploadFooter } from "../../Footer";
import { DocumentDetailsInstructions } from "../../Instructions";
import { DocumentDetailsMetadata } from "../../Metadata";
import { DocumentDetailsRequiredBySection } from "../../RequiredBySection/Section";
import { DocumentPageScrollWrapper } from "../../ScrollWrapper";
import { DocumentDetailsStatusCard } from "../../StatusCard";
import { useDocumentDetailsActions } from "../../useDocumentDetailsActions";
import { useRequirementDetailsContext } from "../../useRequirementDetailsContext";

export function DocumentDetailsPersonalIdStripeVerificationPage() {
  const { requirement: workerRequirement } = useRequirementDetailsContext();
  const history = useHistory();
  const scrollRef = useRef<HTMLDivElement>(null);

  const { status, requirement, requirementId } = workerRequirement;
  const { name } = requirement?.attributes ?? {};

  const handleUploadButtonClick = async () => {
    history.replace(
      generatePath(`${DOCUMENT_STRIPE_VERIFICATION_SELECT_SUBTYPE_FULL_PATH}`, {
        requirementId,
      })
    );
  };

  const { deleteDocument } = useDocumentDetailsActions();

  return (
    <PageWrapper variant="tertiary">
      <StickyScrollPageHeader
        shouldWrapTitle
        title={name ?? ""}
        headerVariant="tertiary"
        scrollContainerRef={scrollRef}
      />

      <DocumentPageScrollWrapper ref={scrollRef}>
        <DocumentDetailsMetadata />
        <DocumentDetailsStatusCard
          hideViewDocument={status === WorkerRequirementStatus.IN_REVIEW}
        />
        <DocumentDetailsInstructions />
        <DocumentDetailsRequiredBySection />
      </DocumentPageScrollWrapper>

      <DocumentUploadFooter
        status={status}
        uploadButtonText="Start Personal ID Verification"
        replaceUploadButtonText="Verify Personal ID Again"
        onUploadButtonClick={handleUploadButtonClick}
        onDeleteButtonClick={deleteDocument}
      />
    </PageWrapper>
  );
}
